export const selectInstruments = state => state.instruments.instruments;
export const selectAudioInstruments = state => state.audioInstruments